import React from "react"

//Store
import { createStore, applyMiddleware, compose, combineReducers } from "redux"
// import Loggers from "./Loggers"
import { Provider } from "react-redux"
import reduxThunk from "redux-thunk"

import { Router, Route, Switch } from "react-router-dom"
import { createBrowserHistory } from "history"

//Routers
import { BrowserRouter } from "react-router-dom"

import ListsUser from "./reducers/ListsUserReducers"
import ListsProject from "./reducers/ListsProjectReducers"
import ListsUserFromImportReducers from "./reducers/ListsUserFromImportReducers"
import ListsCustomer from "./reducers/ListsCustomerReducers"
import Answers from "./reducers/AnswersReducers"
import ListsEmailHotAlertReducers from "./reducers/ListsEmailHotAlertReducers"
import ListsQualityDataReducers from "./reducers/ListsQualityDataReducers"
import ListsEmailHotAlertCheckReducers from "./reducers/ListsEmailHotAlertCheckReducers"
import ListsCallInType from "./reducers/ListsCallInTypeReducers"
import ListsCallInTypeSub1 from "./reducers/ListsCallInTypeSub1Reducers"
import ListsCustomerSurvey from "./reducers/ListsCustomerSurveyReducers"
import ListsThemeSMS from "./reducers/ListsThemeSMSReducers"
import Credit from "./reducers/CreditReducers"

const reducsers = combineReducers({
  listsUser: ListsUser,
  listsProject: ListsProject,
  listsCustomer: ListsCustomer,
  listsUserFromImport: ListsUserFromImportReducers,
  answers: Answers,
  listsEmailHotAlert: ListsEmailHotAlertReducers,
  listsQualityData: ListsQualityDataReducers,
  listsEmailHotAlertCheck: ListsEmailHotAlertCheckReducers,
  listsCallInType: ListsCallInType,
  listsCallInTypeSub1: ListsCallInTypeSub1,
  listsCustomerSurvey: ListsCustomerSurvey,
  credit: Credit,
  listsThemeSMS: ListsThemeSMS,
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  reducsers,
  composeEnhancers(applyMiddleware(reduxThunk))
)

const hist = createBrowserHistory()

export default class Store extends React.Component {
  render() {
    const routes = this.props.routers
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Router history={hist}>
            <Switch>
              {routes.map((prop, key) => {
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                )
              })}
            </Switch>
          </Router>
        </BrowserRouter>
      </Provider>
    )
  }
}
